module.exports = __webpack_public_path__ + "img/man-accounting.67a02495.png";